import { render, staticRenderFns } from "./consultDetails.vue?vue&type=template&id=2e55a49c&scoped=true&"
import script from "./consultDetails.vue?vue&type=script&lang=js&"
export * from "./consultDetails.vue?vue&type=script&lang=js&"
import style0 from "./consultDetails.vue?vue&type=style&index=0&id=2e55a49c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55a49c",
  null
  
)

export default component.exports